module.exports = __webpack_public_path__ + "img/game-accounts.b5fbf7b4.svg";